import React from 'react';
import PropTypes from 'prop-types';

const CheckCircle = ({ done }) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 24 24"
    fill="none"
    stroke={done ? 'var(--sl-fg-brand)' : 'var(--sl-text-secondary)'}
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
    style={{ flexShrink: 0 }}
  >
    <circle cx="12" cy="12" r="9" />
    {done && <path d="M8 12l3 3 5-6" />}
  </svg>
);

CheckCircle.propTypes = {
  done: PropTypes.bool,
};

export default CheckCircle;
